// extracted by mini-css-extract-plugin
export default {"menuBlock":"nV-z","title":"oV-z","nav":"pV-z","flexCell":"qV-z","facetLink":"rV-z"};